import { useSelector } from 'react-redux';
import { useMyForm } from '../../../../../../../react-commons/hooks/useMyForm';
import { QueryBaseComponent } from '../../../../../../../react-commons/query/QueryBaseComponent';
import { ResourceType } from '../../../../../resource/enumerations/ResourceType';
import {
    defaultStandardResource,
    StandardMutationResourceSchema,
    StandardPropertyValidation,
    useStandardActions,
} from '../../../../../resource/resources/artifacts/standard/standardResource';
import { Form_DisplayComponentBaseView } from '../../../../reusable-components/form-components/Form_DisplayComponentBaseView';
import { SingleParentedOverviewComponent } from '../../../../reusable-components/resource-overviews/SingleParentedOverviewComponent';
import { selectNoScopeValidationScope, selectReadOnly } from '../../../../util/useSelectorFunctions';
import { StandardContent } from './StandardContent';

const StandardOverviewContent = ({ id, displayedInOverview }: { id: string; displayedInOverview: boolean }) => {
    const readOnly = useSelector(selectReadOnly);

    const standardActions = useStandardActions();
    const standardQuery = standardActions.useGetResource(id);
    const updateStandard = standardActions.useUpdateResource();

    const { form, formNames, onSubmit } = useMyForm({
        schema: StandardMutationResourceSchema,
        defaultValues: defaultStandardResource,
        submitHandler: async (data) => {
            await updateStandard.mutateAsync({
                resource: data,
                id: data.id,
            });
        },
        reactiveValues: standardQuery.data,
    });

    return (
        <QueryBaseComponent name="Standard" query={standardQuery}>
            <Form_DisplayComponentBaseView onSubmit={onSubmit} form={form} canSubmitDefaultValue={false}>
                <StandardContent
                    displayedInOverview={displayedInOverview}
                    form={form}
                    formNames={formNames}
                    readOnly={readOnly}
                    id={id}
                />
            </Form_DisplayComponentBaseView>
        </QueryBaseComponent>
    );
};

export const StandardOverviewComponent = ({ parentId }: { parentId: string }) => {
    const validationScope = useSelector(selectNoScopeValidationScope);

    const standardActions = useStandardActions();

    const parametersQuery = standardActions.useGetAllResources(parentId);

    const resourceType = ResourceType.STANDARD;

    return (
        <QueryBaseComponent name="Standards" query={parametersQuery}>
            <SingleParentedOverviewComponent
                label={'Standards'}
                resourceQuery={parametersQuery}
                content={(id, displayedInOverview) => (
                    <StandardOverviewContent id={id} displayedInOverview={displayedInOverview} />
                )}
                propertyValidationInformation={{
                    namePropertyIdentifier: StandardPropertyValidation.NAME,
                    resourceType,
                }}
                validationScope={validationScope}
                parentId={parentId}
            />
        </QueryBaseComponent>
    );
};
